import { SafeArea, SystemBarsStyle } from "@capacitor-community/safe-area";
import { Capacitor } from "@capacitor/core";

export const configSafeArea = () => {
  if (!Capacitor.isNativePlatform()) return;

  // v7 of the plugin makes the system bars transparent out of the box,
  // so only the content style has to be set (light content on a dark background).
  SafeArea.setSystemBarsStyle({ style: SystemBarsStyle.Dark });
};
